import { useEffect, useState } from "react"
import { loadStrengthRadarData, type StrengthRadarData } from "@/lib/strengthTargets"
import type { WizardSubmissionRow } from "@/lib/supabase"

/**
 * Charge une fois les données du radar de force et les cibles du bloc en cours.
 *
 * Mutualisé entre la section radar et la liste des records du Profil : les deux ont besoin
 * de la cible du bloc, et `loadStrengthRadarData` peut écrire (création des cibles au test
 * initial, ajustement au test intermédiaire). Deux appels concurrents resteraient corrects —
 * les écritures sont idempotentes — mais doubleraient inutilement les requêtes.
 *
 * `reloadKey` permet de rafraîchir après une saisie de 1RM : un record modifié change le
 * pourcentage de cible atteint affiché.
 */
export function useStrengthRadar(
  wizard: WizardSubmissionRow | null,
  reloadKey: number = 0
): { data: StrengthRadarData | null; loading: boolean } {
  const [data, setData] = useState<StrengthRadarData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!wizard) {
      setData(null)
      setLoading(false)
      return
    }
    let mounted = true
    setLoading(true)
    loadStrengthRadarData(wizard)
      .then((result) => {
        if (mounted) setData(result)
      })
      .catch((err) => {
        console.error("[useStrengthRadar] chargement échoué :", err)
        if (mounted) setData(null)
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [wizard, reloadKey])

  return { data, loading }
}
